import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { day: 'Mon', avg: 92 },
  { day: 'Tue', avg: 95 },
  { day: 'Wed', avg: 90 },
  { day: 'Thu', avg: 93 },
  { day: 'Fri', avg: 88 },
];

export default function AttendanceByDayChart() {
  return (
    <div className="bg-white rounded-xl shadow p-6 h-[300px] flex flex-col">
      <div className="font-semibold text-lg text-slate-800 mb-2">Attendance by Day</div>
      <div className="flex-1 flex items-end justify-center">
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorAttendanceBarVerticalByDay" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2563eb" stopOpacity={0.8}/>
                <stop offset="100%" stopColor="#2563eb" stopOpacity={0.4}/>
              </linearGradient>
            </defs>
            <CartesianGrid vertical={false} strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="day" axisLine={false} tickLine={false} tick={{ fill: '#94a3b8', fontSize: 13 }} />
            <YAxis axisLine={false} tickLine={false} tick={{ fill: '#cbd5e1', fontSize: 12 }} domain={[0, 100]} />
            <Tooltip contentStyle={{ borderRadius: 12, border: 'none', boxShadow: '0 2px 8px #0001' }} labelStyle={{ color: '#64748b' }} />
            <Bar dataKey="avg" fill="url(#colorAttendanceBarVerticalByDay)" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
} 